import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";

function Pagination({ pageSize, totalCount, pageCount, page, setPageQuery }) {
  const updatePage = (pageNumber) => {
    var offset = pageNumber * pageSize;
    if (pageNumber < 0) {
      offset = 0;
    }
    if (pageNumber >= pageCount) {
      offset = (pageCount - 1) * pageSize;
    }
    const pageQuery = `skip=${offset}&take=${pageSize}`;
    console.log(pageQuery);
    setPageQuery(pageQuery);
  };
  return (
    <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6 dark:border-white/10 dark:bg-transparent">
      <div className="flex flex-1 justify-between sm:hidden">
        <button
          onClick={() => updatePage(page - 1)}
          className="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-white/10 dark:bg-white/5 dark:text-gray-200 dark:hover:bg-white/10"
        >
          Previous
        </button>
        <button
          onClick={() => updatePage(page + 1)}
          className="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-white/10 dark:bg-white/5 dark:text-gray-200 dark:hover:bg-white/10"
        >
          Next
        </button>
      </div>
      <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
        <div>
          <p className="text-sm text-gray-700 dark:text-gray-300">
            Showing <span className="font-medium">{page * pageSize + 1}</span>{" "}
            to <span className="font-medium">{page * (pageSize * 2) + 1}</span>{" "}
            of <span className="font-medium">{totalCount}</span> results
          </p>
        </div>
        <div>
          <nav
            aria-label="Pagination"
            className="isolate inline-flex -space-x-px rounded-md shadow-xs dark:shadow-none"
          >
            <button
              onClick={() => updatePage(page - 1)}
              className="relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 inset-ring inset-ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 dark:inset-ring-gray-700 dark:hover:bg-white/5"
            >
              <span className="sr-only">Previous</span>
              <IconChevronLeft aria-hidden="true" className="size-5" />
            </button>
            {[...Array(pageCount).keys()].map((i) => (
              <button
                onClick={() => updatePage(i)}
                className={page === i ? selectedPageClass : basePageClass}
              >
                {i + 1}
              </button>
            ))}
            <button
              onClick={() => updatePage(page + 1)}
              className="relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 inset-ring inset-ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 dark:inset-ring-gray-700 dark:hover:bg-white/5"
            >
              <span className="sr-only">Next</span>
              <IconChevronRight aria-hidden="true" className="size-5" />
            </button>
          </nav>
        </div>
      </div>
    </div>
  );
}
const basePageClass =
  "relative hidden items-center px-4 py-2 text-sm font-semibold text-gray-900 inset-ring inset-ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 md:inline-flex dark:text-gray-200 dark:inset-ring-gray-700 dark:hover:bg-white/5";
const selectedPageClass =
  "relative z-10 inline-flex items-center bg-indigo-600 px-4 py-2 text-sm font-semibold text-white focus:z-20 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 dark:bg-indigo-500 dark:focus-visible:outline-indigo-500";
export default Pagination;
